import React from "react";
import { AppShell } from "@/components/AppShell";
import { TimerSuite } from "@/components/TimerSuite";
import { Card } from "@/components/ui/card";

export default function Timers() {
  return (
    <AppShell title="Timers">
      <Card className="rounded-2xl bg-card border-border p-4">
        <TimerSuite />
      </Card>
      <p className="text-center text-xs text-muted-foreground mt-4">Stopwatch · Countdown · Interval · EMOM · AMRAP · Rest · Laps</p>
    </AppShell>
  );
}
